const tracksValidationNL = {
    "trackName": {
        "required": "De tracknaam is verplicht",
        "length": "De tracknaam moet meer dan 1 en minder dan 255 tekens lang zijn",
        "regexp": "De tracknaam mag alleen bestaan uit alfabetische tekens, nummers, spaties en underscores"
    },
    "mix_name": {
        "required": "Voer de mixnaam in",
        "regexp": "De mixnaam mag alleen bestaan uit alfabetische tekens, nummers, spaties en underscores"
    },
    "artistName": {
        "required": "Selecteer een artiest"
    },
    "artistType": {
        "required": "Selecteer een artiesttype"
    },
    "atleastOneMainArtist": {
        "required": "Er moet ten minste één artiest de hoofdartiest zijn"
    },
    "duplicateArtists": {
        "required": "Er zijn twee of meer artiesten met dezelfde naam."
    },
    "publisherName": {
        "required": "Selecteer een uitgever"
    },
    "publisherAuthor": {
        "required": "Voer de echte voor- en achternaam van de persoon in."
    },
    "contributorName": {
        "required": "Selecteer een bijdrager"
    },
    "contributorRole": {
        "required": "Selecteer een rol voor de bijdrager"
    },
    "atleastOneComposer": {
        "required": "Er moet ten minste één bijdrager een componist zijn"
    },
    "atleastOneLyricist": {
        "required": "Er moet ten minste één bijdrager een tekstschrijver zijn"
    },
    "copyright": {
        "required": "Copyright is verplicht",
        "regexp": "Het copyright mag alleen bestaan uit alfabetische tekens, nummers, spaties en underscores"
    },
    "copyrightYear": {
        "required": "Copyrightjaar is verplicht",
        "regexp": "Het copyrightjaar moet een geldig jaar zijn"
    },
    "ISRC": {
        "required": "Geef ISRC op of markeer Genereer ISRC",
        "regexp": "Voer een geldige ISRC-code in of laat leeg"
    },
    "DA_ISRC": {
        "required": "Geef Dolby Atmos ISRC op of markeer Genereer ISRC",
        "regexp": "Voer een geldige ISRC-code in of laat leeg"
    },
    "trackLanguage": {
        "required": "Tracktaal is verplicht. Selecteer de taal van uw tracknaam."
    },
    "trackVocals": {
        "required": "Trackvocalen zijn verplicht. Selecteer de taal van uw vocalen."
    },
    "trackGenre": {
        "required": "Selecteer uw trackgenre."
    },
    "trackSubGenre": {
        "required": "Selecteer uw tracksubgenre"
    },
    "featuringArtistMissing": {
        "required": "De track moet de vermelde gastartiest correct toewijzen aan een gastartiestrol. Pas aan en dien opnieuw in."
    }
};

export default tracksValidationNL;